import { isObjectRecord } from "../../typeGuards";
import { ArsTableCellType, ArsTableColumnGroupLabel } from "../interface";
import { isArsTableCellBase } from "./isArsTableCellBase";

/**
 * Type guard for ArsTableColumnGroupLabel, which is a possible type of ArsTableCellBase.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableColumnGroupLabel, false otherwise
 */
export const isArsTableColumnGroupLabel = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableColumnGroupLabel<T> => {
  if (!isObjectRecord(obj)) return false;
  if (!isArsTableCellBase<T>(obj, isT)) return false;

  if (obj.cellType !== ArsTableCellType.ColumnGroupLabel) return false;
  if (!["number", "undefined"].includes(typeof obj.colSpan)) return false;
  if (!["number", "undefined"].includes(typeof obj.rowSpan)) return false;
  if (typeof obj.siblingCount !== "number") return false;
  if (typeof obj.targetId !== "string") return false;
  if (!["number", "undefined"].includes(typeof obj.width)) return false;

  // Everything is good
  return true;
};
